import useSWR from 'swr';
import { CatalogCategoryOut, CatalogService } from '../../api';

const fetcher = async (): Promise<CatalogCategoryOut[]> => CatalogService.getCatalogCategories();

export const useCatalogCategories = () => {
  const { data, error, isLoading, mutate } = useSWR({ opId: 'getCatalogCategories' }, fetcher);
  return { categories: data ?? [], isLoading, isError: error, mutate };
};
